const getDefaultState = () => {
    return {
        call: {
            scenario: false,
            textScenario: '',
            textOffline: 'Введите номер телефона, пожалуйста:',
            textOnline: 'Давайте перезвоню бесплатно за 24 сек.?',
            show: false,
            step: 'first',
            operatorRequest: false,
            recordOffer: false,
            deferred: false,
            workingBranchesToCall: [],
            form: {
                day: '',
                time: '',
                name: '',
                phone: '',
                email: '',
                branch_id: ''
            }
        },
        offlineConnects: {
            on: true, //для отключения, например после выполенния сценария
            menuModel: null,
            menuShowAll: false,
            enable: false,
            step: 'first'
        }
    }
}
// initial state
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setApi(state, api) {
            state.offlineConnects.enable = Boolean(api.options.offline_mode.communication_offer)
            state.call.recordOffer = Boolean(api.options.call_settings.call_record_offer)
            state.call.branchEnable = Boolean(api.options.common.department_choice_enable)
            state.call.workingBranchesToCall = api.working_branches_to_call
            //state.call.workingBranchesToCall = []
        },
        setOfflineConnectsStep(state, step) {
            state.offlineConnects.step = step
        },
        setOfflineConnectsMenuModel(state, val) {
            state.offlineConnects.menuModel = val
        },
        setOfflineConnectsOn(state, val) {
            state.offlineConnects.on = val
        },
        setOfflineConnectsMenuShowAll(state, boolean) {
            state.offlineConnects.menuShowAll = boolean
        },
        setCallShow(state, boolean) {
            state.call.show = boolean
        },
        setCallOperatorRequest(state, boolean) {
            state.call.operatorRequest = boolean
        },
        setCallTextScenario(state, string) {
            state.call.textScenario = string
        },
        setCallStep(state, step) {
            state.call.step = step
        },
        setCall(state, { field, val }) {
            state.call[field] = val
        },
        setCallForm(state, { field, val }) {
            state.call.form[field] = val
        }
    },
    actions: {},
    getters: {
        callShow: (state, getters, rootState, rootGetters) => {
            return (
                getters.callShowOfflineConnectsStepCall ||
                getters.callShowStart ||
                state.call.operatorRequest
            )
        },
        callShowOfflineConnectsStepCall: (state, getters, rootState, rootGetters) => {
            return (
                rootState.chatActiveBtn === 'chat' &&
                state.offlineConnects.step == 'call' &&
                !rootGetters.operator.online
            )
        },
        callShowStart: (state, getters, rootState, rootGetters) => {
            return rootState.chatActiveBtn === 'call'
        },
        callText: (state, getters, rootState, rootGetters) => {
            if (state.call.textScenario) return state.call.textScenario
            if (rootGetters.operator.online) return state.call.textOnline
            else return state.call.textOffline
        },
        offlineConnectsShow: (state, getters, rootState, rootGetters) => {
            return (
                rootState.chatActiveBtn === 'chat' &&
                !rootGetters.operator.online &&
                state.offlineConnects.on
            )
        }
    }
}
